import React, { createContext } from 'react'
import { initialContextState } from './initialContextState'
import useSplunkLogger from '../../hooks/logging/useSplunkLogger'

// Create Context
export const AppContext: any = createContext({ ...initialContextState })

// Create a provider for component to consume and subscribe to changes
export const ContextProvider = (props: any) => {
  const logSplunk = useSplunkLogger()
  const devLogSplunk = (error: Error, extra: any) => {
    console.log('Dev Log Splunk:', error, extra)
  }
  return (
    <AppContext.Provider
      value={{
        logSplunk: import.meta.env.MODE === 'development' ? devLogSplunk : logSplunk
      }}
    >
      {props.children}
    </AppContext.Provider>
  )
}
